import React, { Fragment, useEffect } from 'react';
import { BrowserRouter, Link, Toggle, Icons } from 'components';
import { mount } from './mount';
import { useQuery, useHistory } from 'helpers';
import * as css from 'styles/program/archive.scss';

export const Programs = mount({ tagName: 'app-programs', propsFromServer: true }, props => {
  return (
    <BrowserRouter basename={props.base}>
      <Sidebar {...props} />
      <Content {...props} />
    </BrowserRouter>
  );
});

function Sidebar(props) {
  const { query, merge } = useQuery();
  const history = useHistory();
  return (
    <aside className={css.sidebar}>
      <h4>Programs</h4>
      <div className={css.tagsContainer}>
        <div className={css.subTitle} tabIndex="-1">
          <span className={css.small}>Stream <Icons.Chevron /></span>
          <span className={css.large}>View by stream</span>
        </div>
        <ul className={css.tags}>
          <li>
            { query.stream
              ? <Link to="/" replace>All</Link>
              : <b>All</b>
            }
          </li>
          { props.streams.map(stream =>
            <li key={stream.term_id}>
              { stream.slug == query.stream
                ? <b>
                    { stream.name }
                  </b>
                : <Link to={ '?stream=' + stream.slug } replace>
                    { stream.name }
                  </Link>
              }
            </li>
          ) }
        </ul>
        <div className={css.sidebarExtra}>
          <span></span>
          <hr />
          <div className={css.subTitle}>Filter</div>
          <Toggle label="VETiS Funded" value={query.vetis} onChange={vetis => history.replace(merge({ vetis }))} />
          <Toggle label="Certificate Programs" value={query.certicate} onChange={certicate => history.replace(merge({ certicate }))} />
          <Toggle label="Short Courses" value={query.short} onChange={short => history.replace(merge({ short }))} />
        </div>
      </div>
    </aside>
  );
}

function Content(props) {
  return (
    <div>
      { getGroups(props).map(group =>
          <Fragment key={group.stream.term_id}>
            <h4 className={`tag-${group.stream.term_id}-color`}>{ group.stream.name }</h4>
            <div className={`tag-${group.stream.term_id}-group ${css.grid}`}>
              { group.posts.map(post =>
                <a href={post.url + '#program'} key={post.ID} className={css.card} dangerouslySetInnerHTML={{__html: post.post_content }} />
              ) }
            </div>
          </Fragment>
      ) }
    </div>
  );
}

function getGroups(props) {
  const { query } = useQuery();
  const matchesQuery = post => {
    if (query.vetis && !post.vetis) {
      return false;
    }
    if (query.certicate && !/certificate/i.test(post.post_title)) {
      return false;
    }
    if (query.short && !/short\s+course/i.test(post.code)) {
      return false;
    }
    return true;
  }
  return props.groups.map(group => {
    if (!query.stream || query.stream == group.stream.slug) {
      const posts = group.query.filter(matchesQuery);
      if (posts.length) {
        return {
          ...group,
          posts,
        }
      }
    }
  }).filter(Boolean);
}
